import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { useParams } from "react-router";
import Datetime from "react-datetime";
import moment from "moment";

import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import { withStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Checkbox from "@material-ui/core/Checkbox";
import MenuItem from "@material-ui/core/MenuItem";
import Box from "@material-ui/core/Box";

import AddAlert from "@material-ui/icons/AddAlert";
import Person from "@material-ui/icons/Person";

import GridContainer from "components/Grid/GridContainer.js";
import FilterNoneIcon from "@material-ui/icons/FilterNone";
import Button from "components/CustomButtons/Button.js";
import CardHeader from "components/Card/CardHeader.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import CardBody from "components/Card/CardBody.js";
import CardIcon from "components/Card/CardIcon.js";
import GridItem from "components/Grid/GridItem.js";
import Loader from "components/Loader/Loader.js";
import Card from "components/Card/Card.js";

import { CREATE_PRACTICE_USER_REQUEST, UPDATE_PRACTICE_USER_REQUEST} from "../../redux/users/actions";
import formStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js";
import { CUSTOM_FIELD_DEFAULT_VALUE, FILTER_USER_ROLES } from "../../common/constants";
import { FETCH_CUSTOM_FIELD_REQUEST } from "../../redux/customFields/actions";
import { fetchGetRequest, fetchRequest } from "../../common/service";
import { useComposeDispatcher } from "../../common/hooks";
import { API_BASE_URL } from "../../common/constants";
import { roleBasedRolesList } from "common/helpers";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
const tenantId = "ATS-DEV";

const styles = () => ({
  labelFocused: {
    color: "#E73F3B !important",
  },
  inputFocused: {
    "&:before": {
      borderBottom: "2px solid #E73F3B !important",
    },
    "&:after": {
      borderBottom: "2px solid #E73F3B !important",
    },
    "& input": {
      borderBottom: "#E73F3B !important",
    },
  },
  inputRoot: {
    color: "red",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "red",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "red",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "red",
    },
  },
});

const InputBox = withStyles(styles)((props) => {
  const {
    labelText,
    helperText,
    classes,
    value,
    id,
    info,
    updateInfo,
    type,
    required,
    disabled
  } = props;
  return (
    <TextField
      label={labelText}
      helperText={helperText}
      fullWidth
      disabled={disabled}
      required={required ? required : false}
      type={type ? type : "text"}
      margin="normal"
      color="primary"
      value={value}
      onChange={(e) => {
        let obj = {};
        obj[id] = e.target.value;
        updateInfo({ ...info, ...obj });
      }}
      InputLabelProps={{
        shrink: true,
        classes: {
          focused: classes.labelFocused,
        },
      }}
      InputProps={{
        classes: {
          root: classes.root,
          focused: classes.inputFocused,
        },
      }}
    />
  );
});

const SelectBox = withStyles(styles)((props) => {
  const { disabled, labelText, classes, value, id, info, updateInfo, options, required, customField, setFacilityList } = props;
  return (
    <TextField
      select
      fullWidth
      disabled={disabled || false}
      label={labelText}
      value={value}
      required={required ? required : false}
      margin="normal"
      color="primary"
      onChange={(e) => {
        if (id === "role") {
          const guestAccountDetail = customField.find((val) => val.name === "Guest Account");
          let obj = {};
          obj[id] = e.target.value;
          obj[guestAccountDetail.fieldId] =
            e.target.value === "Guest" ? "Yes" : "No";
          updateInfo({ ...info, ...obj });

          if(e.target.value === "SupplierAdmin" || e.target.value === "SupplierUser") {
            updateInfo(userInfo => ({
              ...userInfo,
              facility: "",
            }));
            setFacilityList([]);
          }
        } else {
          let obj = {};
          obj[id] = e.target.value;
          updateInfo({ ...info, ...obj });
        }
      }}
      InputLabelProps={{shrink: true, classes: {focused: classes.labelFocused}}}
      InputProps={{classes: {root: classes.root, focused: classes.inputFocused}}}
    >
      {options}
    </TextField>
  );
});

const useStyles = makeStyles(formStyle);

export default function AddUser() {
  const { practice, users, customFields } = useSelector((state) => ({
    practice: state.practice,
    users: state.users,
    customFields: state.customFields,
  }));
  
  const classes = useStyles();
  const history = useHistory();
  const { id } = useParams();
  
  const [userCustomFieldsData, setUserCustomFieldsData] = useState({});
  const [refreshData, setRefreshData] = useState(Date.now());
  const [toastStatus, setToastStatus] = useState(false);
  const [facilityList, setFacilityList] = useState([]);
  const [alertMessage, setAlertMessage] = useState("");
  const [companyList, setCompanyList] = useState([]);
  const [userInfo, setUserInfo] = useState({});

  const [updatePracticeAndUser] = useComposeDispatcher(UPDATE_PRACTICE_USER_REQUEST);
  const [createPracticeAndUser] = useComposeDispatcher(CREATE_PRACTICE_USER_REQUEST);
  const [getCustomFieldList] = useComposeDispatcher(FETCH_CUSTOM_FIELD_REQUEST);

  const userDetails = JSON.parse(localStorage.getItem("user-details"));
  const loggedUserRole = userDetails !== null ? userDetails.roles[0].role : "";
  let rolesDropdown = roleBasedRolesList(FILTER_USER_ROLES);

  useEffect(() => {
    if (!["PracticeUser", "PracticeAdmin"].includes(loggedUserRole)) {
      getCompanyList();
      getFacilityList();
    } else {
      setUserInfo(userInfo => ({
        ...userInfo,
        company: userDetails?.roles?.[0]?.supplier?.supplierId,
        facility: userDetails?.roles?.[0]?.practice?.practiceId,
      }));
    }
    
    getCustomFieldList("UserProfile");

    if (id) {
      getUserDetails();
      getUserCustomFieldsData();
    } else {
    }
  }, []);

  const getUserDetails = async() => {
    const endPoint = `${API_BASE_URL}/user/user/${id}`;
    const userDetails = await fetchGetRequest("GET", endPoint);
    // console.log('userDetails', userDetails);
    userDetails.role = userDetails?.roles?.[0]?.role;
    userDetails.company = userDetails?.roles?.[0]?.supplier?.supplierId;
    userDetails.facility = userDetails?.roles?.[0]?.practice?.practiceId;
    setUserInfo(userDetails);
    setRefreshData(Date.now());
  }

  const getUserCustomFieldsData = async() => {
    const endPoint = `${API_BASE_URL}/user/custom-field/data/${id}`;
    const userCustomFieldsData = await fetchGetRequest("GET", endPoint);
    console.log('userCustomFieldsData', userCustomFieldsData);
    setUserCustomFieldsData(userCustomFieldsData);
  }

  const getCompanyList = async() => {
    const endPoint = `${API_BASE_URL}/user/supplier`;
    const list = await fetchGetRequest("GET", endPoint);
    setCompanyList(list?.content || []);
  }

  const getFacilityList = async() => {
    const endPoint = `${API_BASE_URL}/user/practice?pageNumber=0&sortBy=name&sortOrder=ASC`;
    const facilityListData = await fetchGetRequest("GET", endPoint);
    setFacilityList(facilityListData?.content || []);
  }

  useEffect(() => {
    if (customFields.list.length && !id) {
      const updatedData = {};
      for (let i = 0; i < customFields.list.length; i++) {
        const val = customFields.list[i];
        const defaultValue = CUSTOM_FIELD_DEFAULT_VALUE.find((data) => data.key === val.name);
        if (defaultValue) {
          updatedData[val.fieldId] = defaultValue.value;
        }
      }
      setUserInfo((prev) => ({ ...prev, ...updatedData }));
      setRefreshData(Date.now());
    }
  }, [customFields])

  useEffect(() => {
    if (Object.keys(userCustomFieldsData).length) {
      const updatedData = {};
      for (let i = 0; i < userCustomFieldsData.length; i++) {
        const val = userCustomFieldsData[i];
        updatedData[val.field.fieldId] = val.fieldData;
      }
      setUserInfo((prev) => ({ ...prev, ...updatedData }));
      setRefreshData(Date.now());
    }
  }, [userCustomFieldsData])

  let validateForm = () => {
    setToastStatus(false);
    if (
      !userInfo?.firstName ||
      !userInfo?.lastName ||
      !userInfo?.emailAddress ||
      !userInfo?.password ||
      !userInfo?.confirmPassword ||
      !userInfo?.role ||
      !userInfo?.company ||
      customFields.list.filter((val) => !userInfo[val.fieldId]).length > 3
    ) {
      setAlertMessage("Fields mark with asterisk are required");
      setToastStatus(true);
    } else {
      const emailReg = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
      const passwordReq = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
      if (!emailReg.test(userInfo?.emailAddress)) {
        setAlertMessage("Please enter valid email");
        setToastStatus(true);
      } else if (!passwordReq.test(userInfo?.password)) {
        setAlertMessage("Please enter valid password");
        setToastStatus(true);
      } else if (userInfo?.password !== userInfo?.confirmPassword) {
        setAlertMessage("Entered Password is not matching");
        setToastStatus(true);
      } else {
        const customFieldData = [];
        for (let i = 0; i < customFields.list.length; i++) {
          const val = customFields.list[i];
          if (userInfo[val.fieldId]) {
            customFieldData.push({fieldData: userInfo[val.fieldId], field: val});
          }
        }

        let name = `${userInfo.firstName} ${userInfo.lastName}`;
        if (userInfo.middleName) {
          name = `${userInfo.firstName} ${userInfo.middleName} ${userInfo.lastName}`;
        }
        const contactInfo = {
          streetAddress1: userInfo.streetAddress1 || "",
          streetAddress2: userInfo.streetAddress2 || "",
          city: userInfo.city || "",
          state: userInfo.state || "",
          country: userInfo.country || "",
          zipcode: userInfo.zipcode || "",
          primaryPhone: userInfo.primaryPhone || "",
          secondaryPhone: userInfo.secondaryPhone || "",
        };
        const praticeObject = {
          name,
          emailAddress: userInfo.emailAddress,
          supplierId: userInfo.company,
          tenantId,
          contactInfo,
        };
        const userObject = {
          password: userInfo.password,
          user: {
            firstName: userInfo.firstName,
            middleName: userInfo.middleName,
            lastName: userInfo.lastName,
            emailAddress: userInfo.emailAddress,
            password: userInfo.password,
            contactInfo,
            roles: [
              {
                role: userInfo.role === "Guest" ? "PracticeUser" : userInfo.role,
                practice: { practiceId: userInfo.facility },
                supplier: {supplierId: userInfo.company},
              },
            ],
            tenant: { tenantId },
          },
          customData: customFieldData,
        };

        if(["SupplierAdmin", "SupplierUser"].includes(userInfo.role)) {
          delete userObject.user.roles[0].practice;
        }

        if (["Guest"].includes(loggedUserRole)) {
          createPracticeAndUser({
            userObject,
            praticeObject,
            supplierId: userInfo.company,
          });
        } else {
          createUserCall(userObject);
        }
      }
    }
  };

  const createUserCall = async(userObject) => {
    const endPoint = `${API_BASE_URL}/user/user`;
    const response = await fetchRequest("POST", endPoint, userObject, true);
    if (response?.response?.status === 201) {
      setAlertMessage("User created successfully");
      setToastStatus(true);
      if(loggedUserRole !== 'Patient') {
        history.push(`/admin/user`);
      } else {
        history.push(`/admin/dashboard`);
      }
    } else if (response?.response?.status === 412) {
      setAlertMessage(response?.response?.data?.message || "Required information is missing");
      setToastStatus(true);
    } else {
      setAlertMessage(response?.response?.data?.message || "Something went wrong");
      setToastStatus(true);
    }
  }

  let validateUpdateForm = () => {
    setToastStatus(false);
    if (
      !userInfo?.firstName ||
      !userInfo?.lastName ||
      !userInfo?.emailAddress ||
      !userInfo?.role ||
      !userInfo?.company ||
      customFields.list.filter((val) => !userInfo[val.fieldId]).length > 3
    ) {
      setAlertMessage("Fields mark with asterisk are required");
      setToastStatus(true);
    } else {
      const emailReg = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
      if (!emailReg.test(userInfo?.emailAddress)) {
        setAlertMessage("Please enter valid email");
        setToastStatus(true);
      } else {
        const customFieldData = customFields.list.reduce((acc, val) => {
          if (userInfo[val.fieldId]) {
            return [...acc, {
              fieldData: userInfo[val.fieldId],
              field: val,
            }];
          }
          return acc;
        }, []);
        let name = `${userInfo.firstName} ${userInfo.lastName}`;
        if (userInfo.middleName) {
          name = `${userInfo.firstName} ${userInfo.middleName} ${userInfo.lastName}`;
        }
        const contactInfo = {
          streetAddress1: userInfo.streetAddress1,
          streetAddress2: userInfo.streetAddress2,
          city: userInfo.city,
          state: userInfo.state,
          country: userInfo.country,
          zipcode: userInfo.zipcode,
          primaryPhone: userInfo.primaryPhone,
          secondaryPhone: userInfo.secondaryPhone,
        };
        const praticeObject = {
          practiceId: practice?.practiceList[0]?.practiceId,
          name,
          emailAddress: userInfo.emailAddress,
          supplierId: userInfo.company,
          tenantId,
          contactInfo,
        };
        const userObject = {
          user: {
            userId: userInfo.userId,
            firstName: userInfo.firstName,
            middleName: userInfo.middleName,
            lastName: userInfo.lastName,
            emailAddress: userInfo.emailAddress,
            contactInfo,
            roles: [
              {
                role: userInfo.role === "Guest" ? "PracticeUser" : userInfo.role,
                supplier: {supplierId: userInfo.company},
                practice: {practiceId: userInfo.facility},
              },
            ],
            tenant: { tenantId },
          },
          customData: customFieldData,
        };

        if(["SupplierAdmin", "SupplierUser"].includes(userInfo.role)) {
          delete userObject.user.roles[0].practice;
        }

        if (["PracticeUser", "Guest"].includes(loggedUserRole)) {
          updatePracticeAndUser({
            userObject,
            praticeObject,
            supplierId: userInfo.company,
          });
        } else {
          updateUserCall(userObject);
        }
      }
    }
  };

  const updateUserCall = async(userObject) => {
    const endPoint = `${API_BASE_URL}/user/user-custom`;
    const response = await fetchRequest("PUT", endPoint, userObject, true);
    if (response?.response?.status === 200) {
      setAlertMessage("User updated successfully");
      setToastStatus(true);
      if(loggedUserRole !== 'Patient') {
        history.push(`/admin/user`);
      } else {
        history.push(`/admin/dashboard`);
      }
    }
  }

  const unblockUser = async() => {
    console.log('unblockUser');
    const endPoint = `${API_BASE_URL}/user/${userInfo.userId}/unlock`;
    const response = await fetchRequest("PUT", endPoint, {}, true);
    if (response?.response?.status === 200) {
      setAlertMessage("User unblocked successfully");
      setToastStatus(true);
      setTimeout(() => {
        history.push(`/admin/user`);
      }, 1500);
    } else {
      setAlertMessage("Failed to unblock user");
      setToastStatus(true);
    }
  }

  /* console.log(customFields,'userInfo', userInfo); */

  return (
    <GridContainer key={refreshData}>
      {userInfo?.lockOut && <GridItem xs={12}>
        User is Locked out. <Button onClick={unblockUser} color="danger">Unblock</Button>
      </GridItem>}
      <GridItem xs={12}>
        <Card>
          <CardHeader color="danger" icon>
            <CardIcon color="danger">
              <Person />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>User Information</h4>
          </CardHeader>
          <CardBody>
            <GridContainer>
              <GridItem xs={12} sm={12} md={4}>
                <InputBox
                  labelText="First Name"
                  value={userInfo.firstName}
                  id="firstName"
                  required={true}
                  info={userInfo}
                  disabled={loggedUserRole === 'Patient'}
                  updateInfo={setUserInfo}
                />
              </GridItem>
              <GridItem xs={12} sm={12} md={4}>
                <InputBox
                  labelText="Middle Name"
                  id="middleName"
                  value={userInfo.middleName}
                  info={userInfo}
                  disabled={loggedUserRole === 'Patient'}
                  updateInfo={setUserInfo}
                />
              </GridItem>
              <GridItem xs={12} sm={12} md={4}>
                <InputBox
                  labelText="Last name"
                  id="lastName"
                  value={userInfo.lastName}
                  required={true}
                  info={userInfo}
                  disabled={loggedUserRole === 'Patient'}
                  updateInfo={setUserInfo}
                />
              </GridItem>
              <GridItem xs={12} sm={12} md={4}>
                <InputBox
                  labelText="User Email"
                  id="emailAddress"
                  type="email"
                  value={userInfo.emailAddress}
                  required={true}
                  info={userInfo}
                  disabled={loggedUserRole === 'Patient'}
                  updateInfo={setUserInfo}
                />
              </GridItem>
              {!id && (
                <>
                  <GridItem xs={12} sm={12} md={4}>
                    <InputBox
                      labelText="Password"
                      helperText="Please enter password which contain min 8 letter, at least a symbol, upper and lower case letters and a number"
                      id="password"
                      type="password"
                      value={userInfo.password}
                      required={true}
                      info={userInfo}
                      updateInfo={setUserInfo}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={4}>
                    <InputBox
                      labelText="Confirm password"
                      id="confirmPassword"
                      type="password"
                      value={userInfo.confirmPassword}
                      required={true}
                      info={userInfo}
                      updateInfo={setUserInfo}
                    />
                  </GridItem>
                </>
              )}
              {
                loggedUserRole !== 'Patient' &&
                <>
                  <GridItem xs={12} sm={12} md={4}>
                    <SelectBox
                      id="role"
                      labelText="Select Role"
                      required={true}
                      value={userInfo?.role}
                      info={userInfo}
                      customField={customFields.list}
                      setFacilityList={setFacilityList}
                      updateInfo={setUserInfo}
                      options={rolesDropdown.map((val) => (
                        <MenuItem
                          disabled={val === userInfo?.currentRole?.role}
                          classes={{root: classes.selectMenuItem }}
                          key={val.key}
                          value={val.key}
                        >
                          {val.value}
                        </MenuItem>
                      ))}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={4}>
                    {!["PracticeUser", "PracticeAdmin"].includes(loggedUserRole) ? <SelectBox
                      id="company"
                      labelText="Select Company"
                      value={userInfo?.company}
                      info={userInfo}
                      required={true}
                      updateInfo={setUserInfo}
                      options={companyList.map((val) => (
                        <MenuItem classes={{root: classes.selectMenuItem}} key={val?.supplierId} value={val?.supplierId}>{val?.name}</MenuItem>
                      ))}
                    />
                    : <><p>Company</p><p><strong>{userDetails?.roles?.[0]?.supplier?.name}</strong></p></>} 
                  </GridItem>
                  <GridItem xs={12} sm={12} md={4}>
                    {!["PracticeUser", "PracticeAdmin"].includes(loggedUserRole) ? <SelectBox
                      id="facility"
                      labelText="Select Facility"
                      value={userInfo?.facility}
                      info={userInfo}
                      required={true}
                      updateInfo={setUserInfo}
                      disabled={(facilityList.filter((val) => val.supplierId === userInfo?.company).length === 0) || ["SupplierAdmin", "SupplierUser"].includes(userInfo?.role)}
                      options={facilityList.filter((val) => val.supplierId === userInfo?.company).map((val) => (
                        <MenuItem classes={{root: classes.selectMenuItem}} key={val?.practiceId} value={val?.practiceId}>{val?.name}</MenuItem>
                      ))}
                    /> : <><p>Facility</p><p><strong>{userDetails?.roles?.[0]?.practice?.name}</strong></p></>} 
                  </GridItem>
                </>
              }
            </GridContainer>
          </CardBody>
        </Card>
        <Card>
          <CardHeader zeroIndex={true} color="danger" icon>
            <CardIcon color="danger">
              <FilterNoneIcon />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>User Profile Settings</h4>
          </CardHeader>
          <CardBody>
            <GridContainer>
              {customFields.list.map((field) => {
                if(loggedUserRole !== 'Patient') {
                  if (
                    field.name !== "TimeZone" &&
                    field.name !== "Location" &&
                    field.name !== "DayLight_Savings" &&
                    field.name !== "Plot_range_default"
                  ) {
                    let html;
                    if (field.type === "SingleSelect") {
                      html = (
                        <GridItem xs={12} sm={12} md={4}>
                          <SelectBox
                            id={field.fieldId}
                            labelText={field.name}
                            required={true}
                            value={userInfo[field.fieldId]}
                            info={userInfo}
                            updateInfo={setUserInfo}
                            options={field.optionValues.map((val) => (
                              <MenuItem classes={{root: classes.selectMenuItem}} key={val} value={val}>{val}</MenuItem>
                            ))}
                          />
                        </GridItem>
                      );
                    } else if (field.type === "MultiSelect") {
                      html = (
                        <GridItem xs={12} sm={12} md={4}>
                          <Box paddingTop={2}>
                            <Autocomplete
                              multiple
                              fullWidth
                              options={field.optionValues}
                              className={classes.inputColor}
                              disableCloseOnSelect
                              color="primary"
                              renderOption={(option, { selected }) => (
                                <React.Fragment>
                                  <Checkbox
                                    icon={icon}
                                    checkedIcon={checkedIcon}
                                    style={{ marginRight: 8 }}
                                    checked={selected}
                                  />
                                  {option}
                                </React.Fragment>
                              )}
                              onChange={(event, val) => {
                                if (val.length === 0) {
                                  delete userInfo[field.fieldId];
                                } else {
                                  setUserInfo({
                                    ...userInfo,
                                    [field.fieldId]: val,
                                  });
                                }
                              }}
                              value={userInfo[field.fieldId]}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label={field.name}
                                  required={true}
                                  InputLabelProps={{shrink: true, classes: {focused: classes.labelFocused}}}
                                  SelectProps={{classes: { focused: classes.labelFocused }}}
                                />
                              )}
                            />
                          </Box>
                        </GridItem>
                      );
                    } else if (field.type === "MultiLineText") {
                      html = (
                        <GridItem xs={12} sm={12} md={4}>
                          <InputLabel className={classes.datePickerLabel}>
                            {field.name}
                          </InputLabel>
                          <TextareaAutosize
                            value={userInfo[field.fieldId]}
                            rowsMax={5}
                            rowsMin={3}
                            id={field.fieldId}
                            style={{ width: "100%", marginTop: "5px" }}
                            onChange={(e) => {setUserInfo({...userInfo, [field.fieldId]: e.target.value});}}
                          />
                        </GridItem>
                      );
                    } else if (field.name == 'TimeStamp-UP') {
                      html = (
                        <GridItem xs={12} sm={12} md={4}>
                          <InputLabel
                            style={{ fontSize: "12px", marginTop: "16px" }}
                            className={classes.searchBox}
                          >
                            {field.name} *
                          </InputLabel>
                          <Datetime
                            closeOnSelect={true}
                            closeOnClickOutside={true}
                            dateFormat="MM/DD/YYYY"
                            timeFormat="hh:mm a"
                            className={classes.datePicker}
                            value={moment(userInfo[field.fieldId]).format('MM/DD/YYYY hh:mm a')}
                            onChange={(e) => {
                              setUserInfo({
                                ...userInfo,
                                [field.fieldId]: e
                              });
                            }}
                          />
                        </GridItem>
                      );
                    } else if(field.name !== "Migration Date") {
                      /* Migration Date is removed intentionally */
                      console.log('userInfo[field.fieldId]', field.name)
                      html = (
                        <GridItem xs={12} sm={12} md={4}>
                          <InputBox
                            labelText={field.name}
                            id={field.fieldId}
                            required={true}
                            value={userInfo[field.fieldId]}
                            info={userInfo}
                            updateInfo={setUserInfo}
                          />
                        </GridItem>
                      );
                    }
                    return html;
                  }
                } else {
                  if (["T&C accepted", "Privacy Policy Accepted"].includes(field.name)) {
                    let html;
                    if (field.type === "SingleSelect") {
                      html = (
                        <GridItem xs={12} sm={12} md={4}>
                          <SelectBox
                            id={field.fieldId}
                            labelText={field.name}
                            required={true}
                            disabled={loggedUserRole === 'Patient'}
                            value={userInfo?.[field?.fieldId]}
                            info={userInfo}
                            updateInfo={setUserInfo}
                            options={field.optionValues.map((val) => (
                              <MenuItem
                                classes={{
                                  root: classes.selectMenuItem,
                                }}
                                key={val}
                                value={val}
                              >
                                {val}
                              </MenuItem>
                            ))}
                          />
                        </GridItem>
                      );
                    }
                    return html;
                  }
                }
              })}
            </GridContainer>
          </CardBody>
        </Card>
      </GridItem>
      <GridItem xs={12}>
        <Box textAlign="right">
          {["TenantAdmin", "SupplierAdmin", "PracticeAdmin", "PracticeUser"].includes(loggedUserRole) && <>
              <Button onClick={() => { id ? validateUpdateForm() : validateForm()}} color="danger">{id ? "Save" : "Submit"}</Button>
              <Button onClick={() => {history.push(`/admin/user`);}}>Cancel</Button>
            </>
          }
        </Box>
      </GridItem>
      <Snackbar
        place="tr"
        color="danger"
        icon={AddAlert}
        message={alertMessage}
        open={toastStatus}
        closeNotification={() => setToastStatus(false)}
        close
      />
      <Loader status={users.loading || users.userDetail.loading} />
    </GridContainer>
  );
}
